/**
 * This file is auto-generated
 */
export var GetProfileStatusCode;
(function (GetProfileStatusCode) {
    GetProfileStatusCode[GetProfileStatusCode["Success"] = 0] = "Success";
    GetProfileStatusCode[GetProfileStatusCode["UserNotFound"] = 1] = "UserNotFound";
    GetProfileStatusCode[GetProfileStatusCode["InternalError"] = 2] = "InternalError";
    GetProfileStatusCode[GetProfileStatusCode["InvalidRequest"] = 3] = "InvalidRequest";
})(GetProfileStatusCode || (GetProfileStatusCode = {}));
export var UpdateProfileStatusCode;
(function (UpdateProfileStatusCode) {
    UpdateProfileStatusCode[UpdateProfileStatusCode["Success"] = 0] = "Success";
    UpdateProfileStatusCode[UpdateProfileStatusCode["EmailAlreadyInUse"] = 1] = "EmailAlreadyInUse";
    UpdateProfileStatusCode[UpdateProfileStatusCode["InvalidPassword"] = 2] = "InvalidPassword";
    UpdateProfileStatusCode[UpdateProfileStatusCode["UserNotFound"] = 3] = "UserNotFound";
    UpdateProfileStatusCode[UpdateProfileStatusCode["InvalidData"] = 4] = "InvalidData";
    UpdateProfileStatusCode[UpdateProfileStatusCode["InternalError"] = 5] = "InternalError";
})(UpdateProfileStatusCode || (UpdateProfileStatusCode = {}));
export var DeleteAccountReason;
(function (DeleteAccountReason) {
    DeleteAccountReason[DeleteAccountReason["TooExpensive"] = 0] = "TooExpensive";
    DeleteAccountReason[DeleteAccountReason["CouldntFindTemplateILike"] = 1] = "CouldntFindTemplateILike";
    DeleteAccountReason[DeleteAccountReason["MissingFeatureCustomizationOption"] = 2] = "MissingFeatureCustomizationOption";
    DeleteAccountReason[DeleteAccountReason["TooDifficultToUse"] = 3] = "TooDifficultToUse";
    DeleteAccountReason[DeleteAccountReason["SignatureDidntInsertProperly"] = 4] = "SignatureDidntInsertProperly";
    DeleteAccountReason[DeleteAccountReason["FoundBetterSolution"] = 5] = "FoundBetterSolution";
    DeleteAccountReason[DeleteAccountReason["Other"] = 6] = "Other";
})(DeleteAccountReason || (DeleteAccountReason = {}));
export var DeleteAccountStatusCode;
(function (DeleteAccountStatusCode) {
    DeleteAccountStatusCode[DeleteAccountStatusCode["Success"] = 0] = "Success";
    DeleteAccountStatusCode[DeleteAccountStatusCode["InvalidPassword"] = 1] = "InvalidPassword";
    DeleteAccountStatusCode[DeleteAccountStatusCode["UserNotFound"] = 2] = "UserNotFound";
    DeleteAccountStatusCode[DeleteAccountStatusCode["AccessDenied"] = 3] = "AccessDenied";
})(DeleteAccountStatusCode || (DeleteAccountStatusCode = {}));
export const userProfileGatewayMethods = [
    'getProfile',
    'updateProfile',
    'deleteAccount',
];
//# sourceMappingURL=user-profile-api.js.map